import req from './https'

// 使用者相關
export const postLogin = params => req('post', '/login.php', params)
export const getUserInfo = params => req('get', '/getUserInfo.php', params)

// 新增
export const postProduct = params => req('post', '/product/add.php', params)
export const postActivity = params => req('post', '/activity/add.php', params)
export const postSlider = params => req('post', '/slider/add.php', params)

// 獲取列表
export const getProduct = params => req('get', '/product/get.php', params)
export const getActivity = params => req('get', '/activity/get.php', params)
export const getSlider = params => req('get', '/slider/get.php', params)
export const getContact = params => req('get', '/contact/get.php', params)

// 獲取詳細
export const getProductDetail = params => req('get', '/product/getDetail.php', params)
export const getActivityDetail = params => req('get', '/activity/getDetail.php', params)
export const getSliderDetail = params => req('get', '/slider/getDetail.php', params)

// 編輯項目
export const postEditProduct = params => req('post', '/product/edit.php', params)
export const postEditActivity = params => req('post', '/activity/edit.php', params)
export const postEditSlider = params => req('post', '/slider/edit.php', params)

// 刪除項目
export const delProduct = params => req('get', '/product/del.php', params)
export const delActivity = params => req('get', '/activity/del.php', params)
export const delSlider = params => req('get', '/slider/del.php', params)
export const delContact = params => req('get', '/contact/del.php', params)

// 圖片上傳
export const postImage = params => req('post', '/upload.php', params)
